import {handleActions} from 'redux-actions';
import {SEARCH_BAR_ITEMS_SET, SEARCH_BAR_ITEMS_RESET} from './SearchBarActions';
import {ContentItemSearchPayload, ContentItemSearchResponse} from '../../SearchTypes';

export const setSearchBarItems = (
    state: ContentItemSearchPayload,
    {payload}: ContentItemSearchResponse
) => {
    const {rows, total} = payload;

    if (rows)
        return {
            rows,
            total,
            isLoading: false,
        };

    return {
        ...state,
        isLoading: false,
    };
};

export const resetSearchBarItems = () => {
    return initialState;
};

export const initialState = {
    rows: [],
    total: 0,
    isLoading: true,
};

const handlers = {
    [SEARCH_BAR_ITEMS_SET]: setSearchBarItems,
    [SEARCH_BAR_ITEMS_RESET]: resetSearchBarItems,
};

export default handleActions(handlers, initialState);
